export default __webpack_public_path__ + "static/media/496.e11b3545.jpg";